import { Container, Content } from "./styled";

const PanerFarm = () => {
  return (
    <Container>
      <Content>
        <div>
          <h1>
            Green Foundation Plan To Plant Trees Around The Globe To Get Carbon
            Credits
          </h1>
          <button>GET STARTED</button>
        </div>
        <div>
          <p>
            Green Foundation invests in afforestation as part of its efforts to
            promote sustainable practices and mitigate climate change.
            Afforestation involves planting trees in areas where there was
            previously no forest cover, with the aim of increasing the amount of
            carbon stored in the trees and soil. By investing in afforestation,
            GreenFoundation generates carbon credits, which can be sold to
            organizations and individuals looking to offset their carbon
            emissions.
          </p>
          <p>
            In addition to generating carbon credits, afforestation has a range
            of other benefits, including supporting biodiversity, improving air
            and water quality, and providing livelihoods for local communities.
            By planting trees around the globe, GreenFoundation is helping to
            address the Carbon Crisis and build a more sustainable future for
            all.
          </p>
        </div>
        <button>GET STARTED</button>
      </Content>
    </Container>
  );
};
export default PanerFarm;
